import React from 'react';

const Invoice = ({ children }) => (
  <div className="w-full flex p-4 md:p-20 justify-center bg-grey-50">
    {children}
  </div>
);

export default Invoice;
